
























import { Component, Prop, Vue } from 'vue-property-decorator';
import CircleRipple from './circleRipple.vue';

@Component({
  name: 'lb-ripple',
  components: {
    CircleRipple,
  },
})
export default class extends Vue {
  @Prop({ type: Boolean, default: true }) private centerRipple!: boolean;
  @Prop({
    default() {
      return {
        height: '40px',
        width: '40px',
        position: 'absolute',
        top: '-9px',
        left: '-11px',
        overflow: 'hidden',
      };
    },
  }) private styles!: object;
  @Prop({ default: '' }) private color!: string;
  @Prop() private opacity!: number;
  @Prop({ type: Boolean, default: false }) private disabled!: boolean;

  private nextKey: number = 0;
  private ignoreNextMouseDown: boolean = false;
  private ripples: any[] = [];
  private startTime: any = '';
  private handleMove: any = null;
  private firstTouchY: number = 0;
  private firstTouchX: number = 0;


  public mounted() {
    this.ignoreNextMouseDown = false; // 防止既有 touch 又有 mouse点击的情况
  }

  private handleClick() {
    this.$emit('click');
  }
  private start(event: any, isRippleTouchGenerated: any) {
    // 过滤 touchstart 和 mousedown 同时存在的情况
    if (this.ignoreNextMouseDown && !isRippleTouchGenerated) {
      this.ignoreNextMouseDown = false;
      return;
    }
    // 添加一个 波纹元素组件
    this.ripples.push({
      key: this.nextKey++,
      color: this.color,
      opacity: this.opacity,
      backgroundColor: this.centerRipple ? {} : this.getRippleStyle(event), // 不是从中心扩展的需要计算波纹元素的位置
    });
    this.ignoreNextMouseDown = isRippleTouchGenerated;
  }
  private end() {
    if (this.ripples.length === 0) { return; }
    this.ripples.splice(0, 1); // 删除一个波纹元素
    this.stopListeningForScrollAbort(); // 结束 touch 滚动的处理
  }
  private handleMouseDown(event: any) {
    // 只监听鼠标左键的点击
    if (event.button === 0 && !this.disabled) {
      this.start(event, false);
    }
  }
  private handleTouchStart(event: any) {
    event.stopPropagation(); // 防止多个波纹点击组件嵌套
    if (event.touches  && !this.disabled) {
      this.startListeningForScrollAbort(event); // 启动 touchmove 触发滚动处理
      this.startTime = Date.now();
    }
    this.start(event.touches[0], true);
  }
  // touchmove 结束波纹控制
  private stopListeningForScrollAbort() {
    if (!this.handleMove) { this.handleMove = this.handleTouchMove.bind(this); }
    document.body.removeEventListener('touchmove', this.handleMove, false);
  }
  private startListeningForScrollAbort(event: any) {
    this.firstTouchY = event.touches[0].clientY;
    this.firstTouchX = event.touches[0].clientX;
    document.body.addEventListener('touchmove', this.handleMove, false);
  }
  private handleTouchMove(event: any) {
    const timeSinceStart = Math.abs(Date.now() - this.startTime);
    if (timeSinceStart > 300) {
      this.stopListeningForScrollAbort();
      return;
    }
    const deltaY = Math.abs(event.touches[0].clientY - this.firstTouchY);
    const deltaX = Math.abs(event.touches[0].clientX - this.firstTouchX);
    // 滑动范围在 > 6px 结束波纹点击效果
    if (deltaY > 6 || deltaX > 6) { this.end(); }
  }
  private getRippleStyle(event: any) {
    const holder = this.$refs.holder;
    //  这个方法返回一个矩形对象，包含四个属性：left、top、right和bottom。分别表示元素各边与页面上边和左边的距离。
    // @ts-ignore
    const rect = holder.getBoundingClientRect();
    // 获取点击点的位置
    let x = event.offsetX;
    let y;
    if (x !== undefined) {
      y = event.offsetY;
    } else {
      x = event.clientX - rect.left;
      y = event.clientY - rect.top;
    }
    // 获取最大边长
    let max;
    if (rect.width === rect.height) {
      max = rect.width * 1.412;
    } else {
      max = Math.sqrt(
        (rect.width * rect.width) + (rect.height * rect.height),
      );
    }
    const dim = (max * 2) + 'px';
    return {
      "width": dim,
      "height": dim,
      // 通过margin控制波纹中心点和点击点一致
      'margin-left': -max + x + 'px',
      'margin-top': -max + y + 'px',
    };
  }
}
